<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["loyalty_programs"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["edit_your_loyalty_card"] }}
      </p>
      <input
        type="text"
        v-model="this.$store.getters.USER.selectedLoyaltyProgram.label"
        autocomplete="off"
        disabled
      />
      <input
        type="text"
        v-model="this.$store.getters.USER.selectedLoyaltyProgram.code"
        autocomplete="off"
        disabled
      />
      <barcode
        class="barcode"
        v-if="code"
        v-model="code"
        :options="{ displayValue: true }"
      ></barcode>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="remove()" class="button remove">
        {{ this.$store.getters.TRANSLATIONS["remove"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      cards: [],
      code: this.$store.getters.USER.selectedLoyaltyProgram.code,
      cardIcon: require("@/assets/cardIcon.png"),
      remove: () => {
        this.$modal.show("dialog", {
          text: this.$store.getters.TRANSLATIONS["are_you_sure"],
          buttons: [
            {
              title: this.$store.getters.TRANSLATIONS["no"]
            },
            {
              title: this.$store.getters.TRANSLATIONS["yes"],
              handler: () => {
                /////
                const timeout = setTimeout(() => {
                  this.loading = true;
                }, 0);
                this.$http
                  .delete(
                    `${process.env.SERVER_URL}/DB4C0124E21B11EA87D00242AC130003/${this.$store.getters.USER.selectedLoyaltyProgram.externalId}`,
                    {
                      headers: {
                        "x-access-token": this.$storage.get("parkendaToken")
                      }
                    }
                  )
                  .then((response) => {
                    console.log("Delete loyalty response");
                    console.log(response);
                    if (response.status && response.status === 204) {
                      this.$router.push("/loyaltyList");
                    }
                  })
                  .catch((error) => {
                    let text =
                      this.$store.getters.TRANSLATIONS["something_went_wrong"];
                    if (
                      error.response &&
                      error.response.data &&
                      error.response.data.error
                    ) {
                      text = error.response.data.error;
                    }
                    this.$modal.show("dialog", {
                      text,
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$storage.remove("parkendaToken");
                            this.$router.push("/loyaltyList");
                          }
                        }
                      ]
                    });
                  })
                  .finally(() => {
                    clearTimeout(timeout);
                    this.loading = false;
                  });
                /////
              }
            }
          ]
        });
      },
      back: () => {
        this.$router.push("/loyaltyList");
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
input {
  margin: 0px 17vw 3vh;
  width: 65%;
  float: left;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
input::placeholder {
  color: rgba(114, 174, 255, 1);
}
.barcode {
  width: 50%;
  margin: 20px auto 0;
  border: 2px solid rgba(114, 174, 255, 1);
  padding: 10px;
  border-radius: 25px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/LoyaltyVouchers/Edit.vue